import { h } from 'vue';
import { Button } from '@/ui/components/Button';
import { ChecklistRecord } from '@/entities/checklist';
import { tooltip } from '@/ui/components/Tooltip';
import { t } from '@/ui/i18n/i18n';
import { CLICK_EVENTS, trackClick } from '@/services/activityTracker/activityTrackerHelper';

export const openChecklistLogs = (checklist: ChecklistRecord, openActivityModal: Function) => {
  const openModal = (e: MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();

    trackClick(CLICK_EVENTS.CHANGE_LOG_TEMPLATE, { template_id: checklist.id });

    openActivityModal(checklist);
  };

  return tooltip({
    label: t('inspections.view-log-history'),
    position: 'is-top',
  }, [
    h(Button, {
      class: 'checklist-index-page__action-button',
      props: {
        type: 'is-light',
      },
      attrs: {
        iconRight: 'history',
      },
      on: {
        click: (e: MouseEvent) => openModal(e),
      },
    }),
  ], 'label');
};
